// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { MedicalStaffApi } from '../types/medical-staff.types';
import { medicalStaffHttpApi } from './medical-staff.api';
import { medicalStaffMockApi } from './medical-staff.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const medicalStaffApi: MedicalStaffApi = useMock
  ? medicalStaffMockApi
  : medicalStaffHttpApi;
